/**
 * Homepage selectors
 */

import { RootState } from 'types';

import { createSelector } from '@reduxjs/toolkit';

import { initialState } from './slice';

// TODO: Add an explanation for this
const selectDomain = (state: RootState) => state.SnackbarState || initialState;

export const selectSnackbar = createSelector(
  [selectDomain],
  SnackbarState => SnackbarState.snackbar,
);
